import * as React from "react";
import { inject } from "mobx-react";
import { UitkSecondaryButton } from "uitk-react-button";
import { AnalyticsConfig } from "uitk-react-utils";
import { formatText } from "bernie-l10n";

import { DestinationAttractionsProps } from "./typings";
import { ItemKeyHelper } from "components/utility/ItemKeyHelper";
import {
  Action,
  FlexTrackingInfo,
  sendDelayedTrackEvent
} from "components/utility/analytics/FlexAnalyticsUtils";
import { JumplinkItem } from "components/flexComponents/Jumplinks/Jumplinks";
import { AttractionSection } from "./AttractionSection";

@inject("thumbor", "analytics", "dx")
export class DestinationAttractions extends React.Component<DestinationAttractionsProps> {
  private readonly jumplinkRef: React.RefObject<HTMLDivElement>;
  private jumplink: JumplinkItem;

  constructor(props: DestinationAttractionsProps) {
    super(props);
    this.jumplinkRef = React.createRef();
  }

  /* istanbul ignore next line */
  public componentDidMount() {
    const componentHasData: boolean =
      this.props.flexComponent.model.content &&
      !this.props.flexComponent.model.empty &&
      this.props.flexComponent.model.content.pois &&
      this.props.flexComponent.model.content.pois.length > 0;

    this.jumplink = {
      identifier: 2,
      name: "Things To Do",
      icon: "local_activity",
      reference: this.jumplinkRef,
      localisedName: formatText("jumplinks.thingsToDo")
    };
    const checkForExistingReference = (reference: JumplinkItem) => {
      return reference["name"] === this.jumplink.name;
    };

    const addUpdatedReference = (reference: JumplinkItem) => {
      if (this.props.dx && reference["name"] === this.jumplink.name) {
        const index = this.props.dx.jumplinksArray.indexOf(reference);
        this.props.dx.jumplinksArray.splice(index, 1);
        this.props.dx.jumplinksArray.push(this.jumplink);
      }
    };

    if (this.props.dx && componentHasData) {
      if (
        this.props.dx.jumplinksArray.some((reference: JumplinkItem) =>
          checkForExistingReference(reference)
        )
      ) {
        this.props.dx.jumplinksArray.map((reference: JumplinkItem) =>
          addUpdatedReference(reference)
        );
      } else {
        this.props.dx.jumplinksArray.push(this.jumplink);
      }
    }
  }

  /* istanbul ignore next line */
  public componentWillUnmount() {
    if (this.props.dx) {
      if (this.props.dx.jumplinksArray.includes(this.jumplink)) {
        this.props.dx.jumplinksArray.splice(this.props.dx.jumplinksArray.indexOf(this.jumplink), 1);
      }
    }
  }

  public render() {
    const attractionsKeyHelper = new ItemKeyHelper("top-attractions");
    const isCountry: boolean = this.props.context.searchContext.location.type === "country";

    let pois =
      this.props.flexComponent.model &&
      this.props.flexComponent.model.content &&
      this.props.flexComponent.model.content.pois;
    if (pois) {
      pois = pois.filter(attraction => {
        return (
          attraction.name &&
          attraction.media &&
          attraction.media.mediaUrl &&
          attraction.media.mediaUrl.length &&
          attraction.description
        );
      });
    }

    let activities =
      this.props.flexComponent.model &&
      this.props.flexComponent.model.content &&
      this.props.flexComponent.model.content.activities;
    if (activities) {
      activities = activities.filter(attraction => {
        return (
          attraction.name &&
          attraction.media &&
          attraction.media.mediaUrl &&
          attraction.media.mediaUrl.length &&
          attraction.description
        );
      });
    }

    const activitiesTravelGuideUrl =
      this.props.flexComponent.model &&
      this.props.flexComponent.model.content &&
      this.props.flexComponent.model.content.activitiesTravelGuideUrl;

    const carouselAnalytics: AnalyticsConfig = {
      id: "TG.LP.Dest.Attractions",
      callback: (id, description) => {
        const flexTrackingInfo: FlexTrackingInfo = {
          moduleName: id,
          action: Action.SCROLL,
          linkName: description
        };
        sendDelayedTrackEvent(flexTrackingInfo, this.props.analytics);
      }
    };

    /* istanbul ignore next */
    const buttonAnalytics: AnalyticsConfig = {
      id: "TG.LP.Dest.Attractions.Activities.Button",
      callback: (id, description) => {
        const flexTrackingInfo: FlexTrackingInfo = {
          moduleName: id,
          action: Action.CLICK,
          linkName: description
        };
        sendDelayedTrackEvent(flexTrackingInfo, this.props.analytics);
      }
    };

    return (
      <div
        className="DestinationAttractions uitk-cell all-cell-1-1"
        id={this.props.flexComponent.id}
        ref={this.jumplinkRef}
        data-fm={this.props.flexComponent.fmId}
        data-fm-title-id={this.props.flexComponent.fmTitleId}
      >
        {pois &&
          pois.length > 0 && (
            <AttractionSection
              attractions={pois}
              attractionsKeyHelper={attractionsKeyHelper}
              props={this.props}
              headingKey={
                isCountry
                  ? "destinationAttractions.country.pois.title"
                  : "destinationAttractions.city.pois.title"
              }
              carouselAnalytics={carouselAnalytics}
              isActivity={false}
              isCountry={isCountry}
            />
          )}
        {activities &&
        activities.length > 0 && ( // There are never activities for countries.
            <>
              <AttractionSection
                attractions={activities}
                attractionsKeyHelper={attractionsKeyHelper}
                props={this.props}
                headingKey={"destinationAttractions.city.activities.title"}
                carouselAnalytics={carouselAnalytics}
                isCountry={isCountry}
                isActivity={true}
              />
              {activitiesTravelGuideUrl && (
                <div className="uitk-type-center">
                  <UitkSecondaryButton
                    text={
                      this.props.context.searchContext.location.localizedName &&
                      formatText(
                        "destinationAttractions.city.activities.button.label",
                        this.props.context.searchContext.location.localizedName
                      )
                    }
                    href={activitiesTravelGuideUrl}
                    analytics={buttonAnalytics}
                  />
                </div>
              )}
            </>
          )}
      </div>
    );
  }
}

export default DestinationAttractions;
